<div class="position-relative m-4" (mouseenter)="enablePopovers()" (mouseleave)="disablePopovers()">
    <div class="progress position-absolute start-0 top-50 w-100" role="progressbar" aria-label="Progress"
        aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
        <div class="progress-bar bg-secondary"
            [style]="{'width':  (100 * (active - 1) / (questions().length - 1)) + '%'}"></div>
    </div>
    <div class="btn-toolbar justify-content-between">
        @for (question of questions(); track question.sequence_number) {
        <div class="button-anchor">
            <button class="btn btn-sm rounded-circle anchor-button" [ngClass]="{
                        'btn-primary pe-none': question.sequence_number === active,
                        'btn-secondary': question.sequence_number !== active && (question.completion === 'COMPLETED' || question.completion === 'PARTIAL'),
                        'btn-partial': question.completion === 'PARTIAL',
                        'btn-light': question.sequence_number !== active && question.completion ==='EMPTY',
                        'btn-outline-secondary': question.sequence_number < active && question.completion !== 'COMPLETED' && question.completion !== 'PARTIAL',
                        'active': activePopover === question.sequence_number
                    }" [attr.popovertarget]="'popover'+ question.sequence_number"
                (mouseenter)="activatePopover('popover' + question.sequence_number)"
                (click)="jumpTo(question.sequence_number)">{{question.sequence_number}}
            </button>
            <div [attr.id]="'popover'+ question.sequence_number" popover class="border-0 overflow-visible"
                [ngClass]="{'slide-in': popoverCount <= 1 }">
                <div class="card shadow">
                    <div class="card-header">
                        <h5 class="card-title">
                            <div class="row">
                                <div class="col">
                                    <div class="row">
                                        <div class="col-auto">
                                            <div class="my-2 fs-6 text-muted">&nbsp;</div>
                                            <span>{{question.sequence_number}}.</span>
                                        </div>
                                        <div class="col">
                                            <div class="my-2 fs-6 text-muted fst-italic">{{question.theme}}</div>
                                            {{question.subquestions[0].content}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </h5>
                    </div>
                    <div class="card-body">
                        <p class="card-text">
                            {{question.helptext}}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        }
    </div>
</div>
